import React from "react";
import "./css/App.css";

/*Syncfusion Components*/
import '../node_modules/@syncfusion/ej2-base/styles/material.css';
import '../node_modules/@syncfusion/ej2-navigations/styles/material.css';

import Router from "./Router";
import { AuthProvider, CartProvider, ConfigProvider } from "./context";

function App() {
  return (
    <ConfigProvider>
      <AuthProvider>
        <CartProvider>
          <div className="App">
            <Router />
          </div>
        </CartProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
